import React, {Component} from 'react';
import Button from '@material-ui/core/Button';
import { IntercomAPI } from 'react-intercom';
import IntlMessages from 'util/IntlMessages';
import styles from './index.module.css';

class MyFaqResultCard extends Component {

    openFaq = () => {
        window.open(this.props.url, '_blank');
    };

    render() {
        return (
            <div className="jr-card p-0" onClick={this.openFaq} style={{cursor: 'pointer'}}>
                <div className="jr-card-header mb-0 p-4 bg-grey lighten-4">
                    <h3 className="card-heading" dangerouslySetInnerHTML={{ __html: this.props.title }}></h3>
                    <p className="sub-heading" dangerouslySetInnerHTML={{ __html: this.props.subtitle }}>
                    </p>
                </div>
    
                <div className="card-body" dangerouslySetInnerHTML={{ __html: this.props.text }}>
                </div>
                <div className="card-body" style={{paddingTop: '0', color: '#6c757d', textAlign: 'right'}}>
                    <IntlMessages id="pages.faq.clickForMore"/>
                </div>
            </div>
        );
    }
};

export default MyFaqResultCard;
